import { useState } from "react";
import { toast } from "sonner";
import { FileXls, Spinner } from "@phosphor-icons/react";
import { exportDashboard } from "@/lib/procureApi";

export const DashboardExport = () => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await exportDashboard();
      toast.success("Dashboard workbook downloaded");
    } catch {
      toast.error("Export failed");
    } finally {
      setBusy(false);
    }
  };
  return (
    <button
      data-testid="dashboard-export-btn"
      onClick={run}
      disabled={busy}
      title="Team overview + one sheet per buyer (latest snapshot)"
      className="flex items-center gap-2 rounded-sm border border-[#CAD1DB] bg-white px-3.5 py-2 text-sm font-medium text-[#0F172A] transition-colors hover:bg-[#EDEFF3] disabled:opacity-60"
    >
      {busy ? <Spinner size={16} className="animate-spin" /> : <FileXls size={16} weight="bold" className="text-[#F0323E]" />}
      <span className="hidden sm:inline">Export dashboard</span>
    </button>
  );
};
